import { colors } from "@teamrota/rota-design";
import moment from "moment";
import React from "react";
import {
  PlusIcon,
  StyledOpenShiftEmptyCard
} from "../../../GridCard/grid-card.styles";
import OpenShiftWeeklyCard from "../../OpenShiftWeeklyCard/open-shift-weekly-card";
import {
  StyledOpenShiftCell,
  StyledWeeklyView
} from "~/src/containers/scheduler/OpenShifts/OpenShiftTableRow/WeeklyView/weekly-view.styles";

const WeeklyView = ({
  unassignedShifts,
  getInitialShiftData,
  getFifteenMinsInFuture,
  onPressShiftCell,
  setSelectedDayIndex
}) => {
  return (
    <StyledWeeklyView>
      {unassignedShifts?.map((unassignedShift, i) => {
        const shifts = unassignedShift?.shifts;
        const isDayInFuture = moment(unassignedShift?.date).isSameOrAfter(
          moment(),
          "day"
        );
        return (
          <StyledOpenShiftCell
            key={i}
            isBookings={shifts?.length > 0}
            isDayInFuture={isDayInFuture}
          >
            {shifts?.length > 0 && (
              <OpenShiftWeeklyCard
                shifts={shifts}
                onPressShiftCell={onPressShiftCell}
                setSelectedDayIndex={setSelectedDayIndex}
                dayIndex={i}
              />
            )}

            {shifts?.length === 0 && isDayInFuture && (
              <StyledOpenShiftEmptyCard
                lineHeight="4px"
                onClick={() =>
                  getInitialShiftData(
                    i,
                    getFifteenMinsInFuture(unassignedShift.date)
                  )
                }
              >
                <PlusIcon name="PLUS" size="small" color={colors.rotaOrange} />
              </StyledOpenShiftEmptyCard>
            )}
          </StyledOpenShiftCell>
        );
      })}
    </StyledWeeklyView>
  );
};

export default WeeklyView;
